import { ImageFromServer } from '@/components/images/ImageFromServer';
import { ExerciseDTO } from '@/generated';
import { exerciseDetailsListSubheaderStyle, exerciseDetailsPaperListElevation, exerciseDetailsPaperListStyle } from '@/styles';
import { List, ListItem, ListSubheader, Paper, Stack } from '@mui/material';

export const AdditionalImagesComponent = (props: { exercise: ExerciseDTO; setModalImageId: (id: string) => void }) => {
  const { exercise, setModalImageId } = props;

  return exercise.additionalImageIds?.length ? (
    <Paper sx={exerciseDetailsPaperListStyle} elevation={exerciseDetailsPaperListElevation}>
      <List
        sx={{
          display: 'inline-flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          p: 0,
          m: 0,
          listStyle: 'none',
          width: '100%',
          justifyContent: 'flex-start',
        }}
        component={Stack}
        direction="row"
      >
        <ListSubheader sx={{ width: '100%', ...exerciseDetailsListSubheaderStyle }}>Additional Images</ListSubheader>

        {/* <Stack direction={'row'} sx={{ gap: 1, my: 1, flexWrap: 'wrap' }}> */}
        {exercise.additionalImageIds?.map((id) => (
          <ListItem>
            <ImageFromServer onClick={() => setModalImageId(id)} sx={{ width: 50, height: 50 }} thumbnail={false} alt="image" id={id} />
          </ListItem>
        ))}
        {/* </Stack> */}
      </List>
    </Paper>
  ) : (
    <></>
  );
};
